import { useAccountStore } from "features/Account/store/useAccountStore";
import {
  getKeyLevelSettings,
  updateAdminPanelSettings,
} from "features/AdminPanel/modules/utils/AdminPanel.utils";
import { is_empty } from "features/Common/utils/common.utils";
import { logError } from "utils/error";
import { useNotifications } from "utils/hooks";
import { isRequestSuccessful } from "utils/Utils";
import {
  EXIT_INTENT_INITIAL_VALUES,
  EXIT_INTENT_SETTINGS_CONFIG,
  EXIT_INTENT_SETTINGS_KEY,
} from "../modules/ExitIntentFormFields/constants/ExitIntentFormFields.constants";

export const useExitIntentSettingsModal = () => {
  const { notify } = useNotifications();
  const isExitIntentSettingsModalOpen = useAccountStore(
    (state) => state.isExitIntentSettingsModalOpen
  );

  const setIsExitIntentSettingsModalOpen = useAccountStore(
    (state) => state.setIsExitIntentSettingsModalOpen
  );

  const exitIntentInitialValues = useAccountStore(
    (state) => state.exitIntentInitialValues
  );

  const setExitIntentInitialValuesLoading = useAccountStore(
    (state) => state.setExitIntentInitialValuesLoading
  );

  const exitIntentInitialValuesLoading = useAccountStore(
    (state) => state.exitIntentInitialValuesLoading
  );

  const setExitIntentInitialValues = useAccountStore(
    (state) => state.setExitIntentInitialValues
  );

  const openExitIntentSettingsModal = () => {
    setIsExitIntentSettingsModalOpen(true);
  };

  const closeExitIntentSettingsModal = () => {
    setIsExitIntentSettingsModalOpen(false);
  };

  const updateExitIntentsettings = async (formData, form) => {
    const isDirty = form.getState().dirty;
    if (!isDirty) return;
    try {
      const response = await updateAdminPanelSettings({
        payload: {
          feature_key: EXIT_INTENT_SETTINGS_KEY,
          feature_value: formData,
        },
      });

      if (isRequestSuccessful(response.status)) {
        setExitIntentInitialValues(formData);
        notify("Settings updated successfully");
        closeExitIntentSettingsModal();
      }
    } catch (error) {
      logError({ error, occuredAt: "Error updating contact form settings:" });
    }
  };

  const fetchExitIntentSettings = async () => {
    if (!is_empty(exitIntentInitialValues)) return;
    try {
      setExitIntentInitialValuesLoading(true);
      const response = await getKeyLevelSettings([EXIT_INTENT_SETTINGS_KEY]);
      const data = response?.data?.[EXIT_INTENT_SETTINGS_KEY]?.value || {};
      const settingsInitialValues = Object.fromEntries(
        Object.keys(EXIT_INTENT_SETTINGS_CONFIG).map((key) => [
          key,
          data[key] || EXIT_INTENT_INITIAL_VALUES[key],
        ])
      );

      setExitIntentInitialValues(settingsInitialValues);
    } catch (error) {
      logError({ error, occuredAt: "Error fetching initial values:" });
    } finally {
      setExitIntentInitialValuesLoading(false);
    }
  };

  return {
    exitIntentInitialValuesLoading,
    exitIntentInitialValues,
    setExitIntentInitialValues,
    isExitIntentSettingsModalOpen,
    openExitIntentSettingsModal,
    closeExitIntentSettingsModal,
    updateExitIntentsettings,
    fetchExitIntentSettings,
  };
};
